export default __webpack_public_path__ + "static/media/rated-star.0f965ba1.svg";